export const carouselSlides = [
  {
    id: "slide-1",
    title: "沉浸式科幻大片上线流媒体",
    subtitle: "极致光影特效引爆讨论，视觉与叙事谁更重要？",
    tag: "影视热点",
    image:
      "https://readdy.ai/api/search-image?query=epic%20futuristic%20sci-fi%20cityscape%20at%20night%20with%20neon%20lights%20and%20flying%20vehicles%2C%20dramatic%20dark%20background%20with%20warm%20orange%20accents%2C%20cinematic%20wide%20shot%2C%20highly%20detailed%20deep%20shadows&width=1600&height=900&seq=slide-scifi-01&orientation=landscape",
    targetId: "news-1",
  },
  {
    id: "slide-2",
    title: "华语乐坛年度盛典落幕",
    subtitle: "新锐歌手爆冷摘得最佳新人，现场表演视频播放破千万",
    tag: "音乐盛典",
    image:
      "https://readdy.ai/api/search-image?query=grand%20concert%20stage%20with%20warm%20golden%20spotlights%20and%20microphone%20silhouette%2C%20dark%20atmospheric%20background%2C%20cinematic%20wide%20shot%2C%20glowing%20light%20beams%2C%20highly%20detailed&width=1600&height=900&seq=slide-music-02&orientation=landscape",
    targetId: "news-2",
  },
  {
    id: "slide-3",
    title: "开放世界大作实机演示首曝",
    subtitle: "无缝地图与动态天气，年度最受期待游戏全解析",
    tag: "游戏前瞻",
    image:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20open%20world%20landscape%20with%20floating%20islands%20and%20glowing%20crystals%20at%20sunset%2C%20dramatic%20dark%20sky%20with%20orange%20glow%2C%20cinematic%20wide%20shot%2C%20highly%20detailed&width=1600&height=900&seq=slide-game-03&orientation=landscape",
    targetId: "video-3",
  },
  {
    id: "slide-4",
    title: "户外真人秀第三季定档",
    subtitle: "原班人马全员回归，全新挑战与素人互动环节上线",
    tag: "综艺速报",
    image:
      "https://readdy.ai/api/search-image?query=outdoor%20adventure%20scene%20with%20mountains%20and%20camping%20tents%20at%20dusk%2C%20dramatic%20dark%20sky%20with%20warm%20orange%20and%20teal%20accents%2C%20cinematic%20wide%20shot%2C%20highly%20detailed&width=1600&height=900&seq=slide-variety-04&orientation=landscape",
    targetId: "news-3",
  },
];

export const quickEntries = [
  {
    key: "news",
    label: "娱乐资讯",
    desc: "影视音乐八卦一网打尽",
    icon: "ri-newspaper-line",
    to: "/news",
  },
  {
    key: "video",
    label: "精彩视频",
    desc: "MV综艺游戏视频精选",
    icon: "ri-play-circle-line",
    to: "/video",
  },
  {
    key: "game",
    label: "游戏攻略",
    desc: "热门游戏实用攻略库",
    icon: "ri-gamepad-line",
    to: "/game",
  },
  {
    key: "forum",
    label: "互动社区",
    desc: "与同好畅聊娱乐话题",
    icon: "ri-chat-smile-2-line",
    to: "/forum",
  },
];